import React from 'react'
import "../Styles/aboutsection.css";

function AboutSection() {
  return (
    <div className='container'> 
      <div className='header'>
        <div className='icon'>
        </div>
        <div className='topic'>
        Who am I?
        </div>
      </div>
      <div className='content'>I am an undergraduate student in the Faculty of Technology, Rajarata University of Sri Lanka. Through my academic journey, I have acquired a solid foundation in programming languages, algorithms and software engineering principles. Leveraging this knowledge, I have done several projects that have allowed me to apply my technical knowledge and problem-solving skills to practical scenarios. These projects include developing web and desktop applications, creating interactive user interfaces, and building mobile applications.</div>
    </div>
  )
}

export default AboutSection
